import { Outlet, Link } from 'react-router-dom';
import { Button } from 'antd';
import { RollbackOutlined } from '@ant-design/icons';
import logo from '../../assets/logo.png';

const headerStyle = {
  background: '#fff',
  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
  position: 'sticky',
  top: 0,
  zIndex: 100,
};

const headerInnerStyle = {
  maxWidth: 1200,
  margin: '0 auto',
  height: 56,
  display: 'flex',
  alignItems: 'center',
  padding: '0 24px',
};

const logoStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  textDecoration: 'none',
  flexShrink: 0,
};

const PublicLayout = () => (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f7fa' }}>
    <header style={headerStyle}>
      <div style={headerInnerStyle}>
        <Link to="/login" style={logoStyle}>
          <img src={logo} alt="中国资源循环集团" style={{ height: 32, width: 'auto', objectFit: 'contain' }} />
          <span style={{ color: '#d9d9d9', fontSize: 20, fontWeight: 300 }}>|</span>
          <span style={{ fontSize: 15, color: '#333', fontWeight: 500 }}>供应商自助服务平台</span>
        </Link>
        <div style={{ marginLeft: 'auto' }}>
          <Link to="/login">
            <Button type="text" icon={<RollbackOutlined />}>返回登录</Button>
          </Link>
        </div>
      </div>
    </header>
    <main style={{ flex: 1, maxWidth: 1200, width: '100%', margin: '0 auto', padding: 24 }}>
      <Outlet />
    </main>
    <footer style={{ background: '#fff', borderTop: '1px solid #f0f0f0', marginTop: 'auto' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '16px 24px', textAlign: 'center', color: '#999', fontSize: 13 }}>
        &copy; 2026 中国资源循环集团有限公司
      </div>
    </footer>
  </div>
);

export default PublicLayout;
